import { useMutation, useQueryClient } from "@tanstack/react-query"
import { createQuestionOption } from "../../services/questionOptions";
import { IIndicators } from "../../types/indicator";
import { toast } from "react-toastify";

const useCreateQuestionOption = (indicator: IIndicators) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createQuestionOption,
        onMutate: () => {
            indicator.setIsProcessRunning(true);
            indicator.setIsServiceError(null);
        },
        onSuccess: (status) => {
            if (status === 200) {
                queryClient.invalidateQueries({ queryKey: ['question-options'] });
                indicator.setIsProcessRunning(false);
                indicator.setIsServiceError(null);
                toast.success("Question option created successfully");
            }
        },

        onError: (error: any) => {
            indicator.setIsServiceError(error?.response?.data?.message);
            indicator.setIsProcessRunning(false);
            toast.error(error?.response?.data?.message);
        }
    });
};

export default useCreateQuestionOption;